import { CUSTOMER_TYPE_URL } from "../../helpers/api.routes";
import { requests } from "../../helpers/api.services";
import { IPagination } from "../../shared/interfaces/shared/IPagination";
import { ICustomerType } from "../../shared/interfaces/customer-type/ICustomerType";

export const CustomerTypeService = {
  getAll: (params: IPagination) => requests.get(CUSTOMER_TYPE_URL, params),
  create: (params: ICustomerType) => requests.post(CUSTOMER_TYPE_URL, params),
  getSingle: (id: number) => requests.get(`${CUSTOMER_TYPE_URL}/${id}`),
  update: (params: ICustomerType, id: number) =>
    requests.put(`${CUSTOMER_TYPE_URL}/${id}`, params),
  delete: (id: number) => requests.delete(`${CUSTOMER_TYPE_URL}/${id}`),
};
